import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { bearerAuthHeaders } from "@/utils/bearerAuthHeaders";

export const adminApi = createApi({
  reducerPath: "adminApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_PUBLIC_BASE_URL}api`,
    prepareHeaders: (headers, { getState }) => {
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetAdminAnalytics: builder.query({
      query: (options) => {
        return {
          url: `/admin/get-analytics?period=7days`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),

    GetAdminmainAnalytics: builder.query({
      query: (options) => {
        return {
          url: `/admin/admin-analytics?period=year`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),
    GetAdminUsers: builder.query({
      query: (options) => {
        return {
          url: `/admin/users`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),
    GetAdminReports: builder.query({
      query: (options) => {
        return {
          url: `/help-and-feedback/contacts?page=${options?.page}&limit=${options?.limit}`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),
    GetAdminQrCodes: builder.query({
      query: (options) => {
        return {
          url: `/admin/qrcodes?page=${options?.page}&limit=${options?.limit}`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),
     GetAdminanalyticsReports: builder.query({
      query: (options) => {
        return {
          url: `/admin/admin-analytics-document?period=year`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),
    AddAdminDocuments: builder.mutation({
      query: ({ body, token }) => ({
        url: "/admin/documents",
        method: "POST",
        body,
        headers: bearerAuthHeaders(token),
      }),
    }),
    UpdateAdminDocuments: builder.mutation({
      query: ({ body, token, id }) => ({
        url: `/admin/documents/${id}`,
        method: "PUT",
        body,
        headers: bearerAuthHeaders(token),
      }),
    }),
    UpdateAdminReports: builder.mutation({
      query: ({ body, token, id }) => ({
        url: `/help-and-feedback/contact/${id}/status`,
        method: "PUT",
        body,
        headers: bearerAuthHeaders(token),
      }),
    }),
    GetAllAdminDocuments: builder.query({
      query: (options) => {
        return {
          url: `/admin/documents?page=${options?.page}&limit=${options?.limit}`,
          headers: bearerAuthHeaders(options?.token),
        };
      },
    }),
    DeleteAdminUser: builder.mutation({
      query: (options) => ({
        url: `/admin/user/${options?.id}`,
        method: "DELETE",
        headers: bearerAuthHeaders(options?.token),
      }),
    }),
    DeleteAdminQrCodes: builder.mutation({
      query: (options) => ({
        url: `/admin/qrcode/${options?.id}`,
        method: "DELETE",
        headers: bearerAuthHeaders(options?.token),
      }),
    }),
    DeleteDocuments: builder.mutation({
      query: (options) => ({
        url: `/admin/documents/${options?.id}`,
        method: "DELETE",
        headers: bearerAuthHeaders(options?.token),
      }),
    }),
    UpdateAdminUserStatus: builder.mutation({
      query: ({ body, token, id }) => ({
        url: `/admin/user/${id}/status`,
        method: "PUT",
        body,
        headers: bearerAuthHeaders(token),
      }),
    }),
     ToggleAdminNotifications: builder.mutation({
      query: ({ body, token }) => ({
        url: `/admin/notifications/toggle`,
        method: "POST",
        body,
        headers: bearerAuthHeaders(token),
      }),
    }),
    
  }),
});

export const {
  useGetAdminAnalyticsQuery,
  useGetAdminUsersQuery,
  useDeleteAdminUserMutation,
  useUpdateAdminUserStatusMutation,
  useGetAllAdminDocumentsQuery,
  useAddAdminDocumentsMutation,
  useUpdateAdminDocumentsMutation,
  useDeleteDocumentsMutation,
  useGetAdminQrCodesQuery,
  useDeleteAdminQrCodesMutation,
  useGetAdminReportsQuery,
  useUpdateAdminReportsMutation,
  useGetAdminmainAnalyticsQuery,
  useToggleAdminNotificationsMutation,
  useLazyGetAdminanalyticsReportsQuery,
} = adminApi;
